import { useEffect } from 'react';
import { Row, Col, Card } from 'reactstrap';
import useDashboard from './useDashboard';
import moment from 'moment';
import DateRangePicker from '../../sharedComponents/DateRangePicker/DateRangePicker';
import Select, { createFilter } from 'react-select';
import { useSelector } from 'react-redux';
import HighlightsCard from './DashboardCards/HighlightsCard';
import ProductsLocationsCard from './DashboardCards/ProductsLocationsCard';
import DashboardChartsCard from './DashboardCards/DashboardChartsCard';
import BEPDistributorListCard from './DashboardCards/BEPDistributorListCard';
import SlideDrawer from '../../sharedComponents/SlideDrawer/SlideDrawer';
import getWelcomeName from '../../sharedComponents/WelcomeName/getWelcomeName';
import { BsFillGridFill } from 'react-icons/bs';
import { InputLabel } from '@mui/material';
import { InputOption, DropdownIndicator, ValueContainer } from '../../config/customSelect';
import { selectStyles, usStatesAndTerritoriesOptions } from '../../config/constants';
import PageHeader from '../../sharedComponents/Header/PageHeader';

const Dashboard = () => {
  const {
    fromDate, toDate, onApplySearch, onChangeDashboardDates, onChangeSelectedStates, onApplyDate
  } = useDashboard.useDates();
  const { setDashboardTab } = useDashboard.useDashboard();
  const minDate = useSelector(({dates}) => dates.dashMinDate);
  const dashDateString = useSelector(({dates}) => dates.dashDateString);
  const selectedStates = useSelector(({dashboard}) => dashboard.selectedStatesFilter);
  const slideDrawerContents = useSelector(({dashboard}) => dashboard.slideDrawer);
  var mfrName = getWelcomeName() || 'Admin';

  const initializePage = () => {
    setDashboardTab();
  };

  useEffect(initializePage
    //  eslint-disable-next-line  
  , []);

  //  eslint-disable-next-line  
  useEffect(() => onApplySearch(), [dashDateString, selectedStates]);

  //  eslint-disable-next-line  
  useEffect(() => onApplyDate(), [dashDateString]);

  return (
    <>
      <PageHeader title='Dashboard' subtitle="Today's Highlights" icon={<BsFillGridFill fill='url(#icon-gradient)'/>}/>
      <Col className='p-3'>
        <Row className='label-text text-size-14 d-flex align-items-center mx-auto pb-2'>
          <Col className='ps-0'>
            <div className='main-header text-size-20' style={{lineHeight:'23px', fontWeight:'700',letterSpacing:'.0025em' }}>Today's Highlights</div>
          </Col>
          <Col className='col-auto ps-0 pe-0'>
            <Row>
              <Col>
                <InputLabel style={{color: 'black', fontSize: '12px'}}>Select Date Range</InputLabel>
                <DateRangePicker 
                  id='dashboardDateSearch'
                  defaultStartDate={moment(fromDate).format('MM/DD/YYYY')} 
                  defaultEndDate={moment(toDate).format('MM/DD/YYYY')} 
                  minDate={moment(minDate).format('MM/DD/YYYY')} 
                  maxDate={moment().format('MM/DD/YYYY')} 
                  callback={(start, end) => onChangeDashboardDates(start, end)}
                  ranges={{
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'Last 2 Months': [moment().subtract(2, 'month'), moment()],
                    'Last Year': [moment().subtract(1, 'year'), moment()]
                    }
                  }
                />
              </Col>
              <Col>
                <InputLabel style={{color: 'black', fontSize: '12px'}}>Select State</InputLabel>
                <Select 
                  captureMenuScroll={false}
                  isMulti
                  classNamePrefix="custom-select "
                  filterOption={createFilter({ ignoreAccents: false })} 
                  hideSelectedOptions={false}
                  name='state'
                  styles={selectStyles} 
                  options = {usStatesAndTerritoriesOptions}
                  components={{ ValueContainer, Option: InputOption, DropdownIndicator}}
                  onChange = {(e) => onChangeSelectedStates(e)}
                  value = {selectedStates}
                  placeholder='Select State'
                
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row xs={1} md={1} lg={1} xl={1} className='label-text text-size-14 d-flex align-items-center card-row g-2'>
          <Card className='dashboard-card px-3' style={{height: '110px'}}>
            <HighlightsCard />
          </Card>
          <Card className='products-locations-card px-3' style={{maxHeight: '700px'}}>
            <ProductsLocationsCard />
          </Card>
          <Card className='dashboard-card px-3 py-1' style={{minHeight: '750px', height: '100%'}}>
            <DashboardChartsCard />
          </Card>
          <Card className='dashboard-card px-3' style={{minHeight: '450px'}}>
            <BEPDistributorListCard />
          </Card>
        </Row>
        <Row>
          <Col className=' w-fc ms-auto me-0'>
            <div className='text-beplBlue' style={{'display': (mfrName ? 'block' : 'none')}}>*All data is for {mfrName}</div>
          </Col>
        </Row>
        <SlideDrawer title={slideDrawerContents.title} drawerContents={slideDrawerContents.contents}/>
      </Col>
    </>
  );
}

export default Dashboard;